"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapBoxLayer = void 0;
const Tile_1 = __importDefault(require("ol/layer/Tile"));
const XYZ_1 = __importDefault(require("ol/source/XYZ"));
const react_1 = require("react");
const useOLMap_1 = require("../../openlayers/useOLMap");
function MapBoxLayer({ zIndex = 0 }) {
    const map = useOLMap_1.useOLMap();
    const layer = react_1.useMemo(() => {
        return new Tile_1.default({ source: new XYZ_1.default({ url }), zIndex });
    }, [zIndex]);
    react_1.useEffect(() => {
        map.addLayer(layer);
        return () => {
            map.removeLayer(layer);
        };
    }, [map, layer]);
    return null;
}
exports.MapBoxLayer = MapBoxLayer;
const url = 'https://api.mapbox.com/styles/v1/mapbox/light-v10/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWF0dGVucm9uZSIsImEiOiJjazV3ZnZwa2EwYmRiM29ta2tnc2dvOHFlIn0.5uR5jKgCRgYsNNnF7gfYPw';
//# sourceMappingURL=index.js.map